import { createFileRoute, notFound } from "@tanstack/react-router";
import BlogPost from "@/pages/BlogPost";
import { pageHead } from "@/lib/routeHead";
import { blogPostQueryOptions } from '@/lib/blogQueries';
import { BlogLoadError, BlogNotFound } from '@/components/blog/BlogRouteStatus';
export const Route = createFileRoute("/blog/$slug")({
  loader: async ({ params, context }) => {
    const [post, { blogCover, blogCoverSrcSet }] = await Promise.all([
      context.queryClient.ensureQueryData(blogPostQueryOptions(params.slug)),
      import('@/lib/blogImages'),
    ]);
    if (!post) throw notFound();
    return { ...post, coverPreload: post.cover_image ? {
      rel: 'preload', as: 'image', href: blogCover(post.cover_image),
      imageSrcSet: blogCoverSrcSet(post.cover_image), imageSizes: '100vw', fetchPriority: 'high' as const,
    } : null };
  },
  head: ({ loaderData: post, params }) => {
    const description = post?.excerpt || post?.content.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 155) || 'RV advice from Rex & Sons RVs in Castle Hayne, NC.';
    const head = pageHead({ title: post?.title ?? 'RV Blog Article', description, path: `/blog/${params.slug}`, type: 'article' });
    return { ...head,
      links: [...head.links, ...(post?.coverPreload ? [post.coverPreload] : [])],
      scripts: post ? [{ type: 'application/ld+json', children: JSON.stringify({ '@context': 'https://schema.org', '@type': 'BlogPosting', headline: post.title, description, datePublished: post.published_at, author: { '@type': 'Person', name: post.author }, publisher: { '@type': 'Organization', name: 'Rex & Sons RVs' }, mainEntityOfPage: `https://www.rexandsonsrvs.com/blog/${post.slug}` }) }] : [],
    };
  },
  errorComponent: BlogLoadError,
  notFoundComponent: BlogNotFound,
  component: BlogPost,
});
